// This function is mostly to make it obvious why
// something is made global.
export default function exposeToUnity(name, item) {
	window[name] = item;
}
